export const RELATIONSHIPS = {
  FAMILY: "FAMILY",
  FRIEND: "FRIEND",
  MEMBER: "MEMBER",
  INVITE: "INVITE",
  FATHER_MOTHER: "FATHER_MOTHER",
  OTHER: "OTHER",
};

export const relationshipOptions = () => [
  {
    id: RELATIONSHIPS.FAMILY,
    name: "Family",
  },
  {
    id: RELATIONSHIPS.FRIEND,
    name: "Friend",
  },
  {
    id: RELATIONSHIPS.OTHER,
    name: "Other",
  },
  {
    id: RELATIONSHIPS.MEMBER,
    name: "Member",
  },
  {
    id: RELATIONSHIPS.INVITE,
    name: "Invite",
  },
  {
    id: RELATIONSHIPS.FATHER_MOTHER,
    name: "Father / Mother",
  },
];
